<template>
  <VView class="prizes" back-button-to="/menu" :header="$t('prizes.header')">
    <VMedia class="prizes__image">
      <img src="@/assets/prizes.png" />

      <a target="_blank" href="https://krainazabawy.pl/maszyny-pojazdy-budowlane/37086-dickie-construction-zestaw-budowlany-volvo-pojazdy-kask-lopatka-grabki-3729013-4006333066580.html?search_query=dickie+volvo&results=17" class="prizes__pointer animated pulse infinite faster prizes__pointer--one"></a>
      <a target="_blank" href="https://krainazabawy.pl/maszyny-pojazdy-budowlane/37085-dickie-construction-koparka-volvo-z-dzwiekiem-i-swiatlem-30-cm-3725006-4006333065934.html?search_query=dickie+volvo&results=17" class="prizes__pointer animated pulse infinite faster prizes__pointer--two"></a>
      <a target="_blank" href="https://krainazabawy.pl/maszyny-pojazdy-budowlane/35550-dickie-construction-pojazdy-budowlane-volvo-5-pak-3722008-4006333060991.html?search_query=dickie+volvo&results=17" class="prizes__pointer animated pulse infinite faster prizes__pointer--three"></a>
    </VMedia>

    <VButtonGroup>
      <transition name="bounceUp" appear>
        <VButton to="/contest" special>Laureaci</VButton>
      </transition>
    </VButtonGroup>
  </VView>
</template>

<script>
import VView from '@/components/VView.vue';
import VMedia from '@/components/VMedia.vue';
import VButton from '@/components/VButton.vue';
import VButtonGroup from '@/components/VButtonGroup.vue';

export default {
  name: 'Prizes',
  components: {
    VView,
    VMedia,
    VButton,
    VButtonGroup,
  },
};
</script>

<style lang="scss">
.prizes {
  &__image {
    position: relative;
    max-width: 700px;
    margin: 0 auto;
  }

  &__pointer {
    position: absolute;
    top: 50%;
    left: 50%;

    width: 30px;
    height: 30px;

    border-radius: 9999px;

    border: 5px solid #000000;
    background-color: #ff2128;

    &:hover {
      background-color: transparent;
    }

    &--one {
      top: 53%;
      left: 80%;
    }

    &--two {
      top: 80%;
      left: 60%;
    }

    &--three {
      top: 83%;
      left: 86%;
    }
  }
}
</style>
